import { useLingui } from "@lingui/react/macro";
import styles from "./finishedItem.module.scss";
import { Text } from "@medoma/components/Text/Text";
import { humanFormat } from "@medoma/models/date-and-time";

type IFinishedItem = {
  title: string;
  timeStamp?: Date | null | undefined;
};
export const FinishedItem = ({ title, timeStamp }: IFinishedItem) => {
  const { t } = useLingui();
  const finished = t`klart`;
  return (
    <Text element="div" size="small" className={styles.finishedItem}>
      {title}
      {timeStamp
        ? `, ${finished} ${humanFormat(timeStamp, { timeStyle: "short" })}`
        : ""}
    </Text>
  );
};
